import request from '@/utils/request'
const serivceBase = require('@/config/serviceConfig')

// 同步兑换码（特殊兑换码）-获取兑换码信息
export function getRedeemCodeForSpecial(data) {
  return request({
    url: `${serivceBase.IMS}/redeemCodeStream/getRedeemCodeForSpecial`,
    method: 'post',
    data
  })
}
// 兑换码兑换
export function srlForVerify(data) {
  return request({
    url: `${serivceBase.IMS}/redeemCodeStream/srlForVerify`,
    method: 'post',
    data
  })
}
// 发送短信
export function srlForSendVerifyCode(data) {
  return request({
    url: `${serivceBase.IMS}/redeemCodeStream/srlForSendVerifyCode`,
    method: 'post',
    data
  })
}
